<div style="overflow-y: scroll">
  <div class="success-container">
    <ion-col size="3">
      <app-back-button (clicked)="salir()" [text]="'Volver al detalle'">
      </app-back-button>
    </ion-col>
    <div class="circle">
      <check-svg></check-svg>
    </div>

    <h1 class="title mt-16">
      Ingresamos con éxito la solicitud para revocar tu ahorro mensual
    </h1>

    <h2 class="mt-32 body-desktop bold primary-color">¿Qué viene ahora?</h2>

    <p class="header">
      Le avisaremos a tu empleador para que deje de abonar en tu APV.

      <span class="bold primary-color">
        Te sugerimos verificar que haya recibido la información.
      </span>
    </p>

    <div class="title-break-helper"></div>

    <h2 class="body-desktop bold primary-color">Este es tu comprobante</h2>

    <p class="header">
      También lo enviamos a tu correo
      <span class="underlineText">{{ voucherInfo.userMail }}</span> En caso de
      no encontrarlo en tu bandeja principal, por favor, revisa tu spam.
    </p>
    <hr class="linea" />
    <ion-grid class="mb-32">
      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular marginFolio font-weight-500">
            Nº de Folio:
          </p>
        </ion-col>

        <ion-col size="6">
          <p class="body-desktop-regular marginFolio font-weight-400">
            {{ voucherInfo.documentNumber }}
          </p>
        </ion-col>
      </ion-row>

      <hr />

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">
            Fecha de solicitud:
          </p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.requestDate }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">
            Término de aporte
          </p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.stopDate }}
          </p>
        </ion-col>
      </ion-row>

      <hr />

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">
            <strong>Datos Empleador</strong>
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">
            Nombre
          </p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.employerBusiness }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Rut</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.employerRut }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Correo</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.employerMail }}
          </p>
        </ion-col>
      </ion-row>

      <hr />

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12">
            <strong>Tus datos</strong>
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Nombre</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.userFullName }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary mb-helper">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Rut</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.userRut }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="text-secondary">
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-500">Correo</p>
        </ion-col>
        <ion-col size="6">
          <p class="body-desktop-regular mb-0 mt-12 font-weight-400">
            {{ voucherInfo.userMail }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row
        style="padding: 0"
        class="mt-24 width-percent-100"
        *ngIf="!isMobile"
      >
        <ion-col size="12" class="width-percent-100">
          <ion-button class="mt-0 btn-suscribe" (click)="downloadMyFile()" (keypress)="true">
            <ion-label class="control-step-button-text font-weight-700 ion-text-nowrap">
              Descargar comprobante
            </ion-label>
            <span class="apv-button-arrow-container margin-left-button-helper">
              <download-svg></download-svg>
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
